import { ReportValues } from "common/api/org.service";
import { checkDate } from "common/helpers/Date";
import { Map, Record, List, fromJS } from "immutable";
import { DateStringNumber } from ".";
import { commissionCustomConfigfromJSON } from "common/records/CommissionCustomConfig";

export const fromJSON = (json: Partial<ISettingsData>): SettingsRecord => {
  const record: ISettingsRecord = { ...(json as any) };

  record.acl = fromJS(json.acl) as any;

  record.config = json.config ? (fromJS(json.config) as any) : Map();
  if (json.config?.estimator?.commission_calculator?.custom_config) {
    record.config = record.config.setIn(
      ["estimator", "commission_calculator", "custom_config"],
      commissionCustomConfigfromJSON(json.config.estimator.commission_calculator.custom_config),
    );
  }

  if (json.created_at) {
    record.created_at = checkDate(json.created_at);
  }

  if (json.updated_at) {
    record.updated_at = checkDate(json.updated_at);
  }
  return new SettingsRecord(record);
};

export const toJSON = (setting: SettingsRecord): ISettingsData => {
  const json: Partial<ISettingsData> = setting.toJS();

  if (json.id === 0) {
    delete json.id;
  }

  if (json.org_id === 0) {
    delete json.org_id;
  }

  return json as ISettingsData;
};

export type SettingsAclKeys =
  | "tools"
  | "design_tools"
  | "visualizations"
  | "profile"
  | "reports"
  | "measurements"
  | "estimator"
  | "job_list";

export type SettingsAclValues =
  | "renoworks_masking"
  | "eagleview_order"
  | "google_maps"
  | "bing_ortho"
  | "bing_birdseye"
  | "zoom_earth"
  | "terra_server"
  | "pictometry_online"
  | "pictometry_connect"
  | "provia"
  | "renoworks"
  | "hover"
  | "cronofy"
  | "annotator"
  | "rapid_area"
  | "satellite_measure"
  | "fencing_tool"
  | "appointment_time"
  | "estimate_amount"
  | "full"
  | "multiple_groups"
  | "price_comparison"
  | ReportValues;

export type SettingsConfigKeys =
  | "billing"
  | "email"
  | "integrations"
  | "job_menu"
  | "screen_share"
  | "signature_settings"
  | "price_presentation"
  | "visualization"
  | "estimator";

export interface ISettingsData {
  id: number;
  org_id: number;
  acl: { [key in SettingsAclKeys]?: SettingsAclValues[] };
  config: { [key in SettingsConfigKeys]?: any };
  created_at: DateStringNumber;
  updated_at: DateStringNumber;
}

export interface ISettingsRecord {
  id: number;
  org_id: number;
  acl: Map<SettingsAclKeys, List<SettingsAclValues>>;
  config: Map<SettingsConfigKeys, any>;
  created_at: Date;
  updated_at: Date;
}

const defaultSettingsProps: ISettingsRecord = {
  id: 0,
  org_id: 0,
  acl: Map<SettingsAclKeys, List<SettingsAclValues>>(),
  config: Map<SettingsConfigKeys, any>(),
  created_at: new Date(),
  updated_at: new Date(),
};

export class SettingsRecord extends Record(defaultSettingsProps) implements ISettingsRecord {}
